import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import { AuthProvider, useAuth } from "@/lib/auth";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import NewQuote from "@/pages/NewQuote";
import Quotes from "@/pages/Quotes";
import QuoteDetail from "@/pages/QuoteDetail";
import TimeClock from "@/pages/TimeClock";
import Personale from "@/pages/Personale";
import EmployeeDetail from "@/pages/EmployeeDetail";
import PriceList from "@/pages/PriceList";
import Subscription from "@/pages/Subscription";
import Profile from "@/pages/Profile";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Terms from "@/pages/Terms";
import Admin from "@/pages/Admin";
import Referral from "@/pages/Referral";
import ComputoVerify from "@/pages/ComputoVerify";

function Protected({ children, requireOnboarding = true }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-[#0A0A0A] text-[#A3A3A3] flex items-center justify-center">…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (requireOnboarding && !user.sector) return <Navigate to="/onboarding" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/onboarding" element={<Protected requireOnboarding={false}><Onboarding /></Protected>} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/preventivo/nuovo" element={<Protected><NewQuote /></Protected>} />
            <Route path="/preventivi/:id/modifica" element={<Protected><NewQuote /></Protected>} />
            <Route path="/preventivi" element={<Protected><Quotes /></Protected>} />
            <Route path="/preventivi/:id" element={<Protected><QuoteDetail /></Protected>} />
            <Route path="/timbratura" element={<Protected><TimeClock /></Protected>} />
            <Route path="/personale" element={<Protected><Personale /></Protected>} />
            <Route path="/personale/dipendenti/:id" element={<Protected><EmployeeDetail /></Protected>} />
            <Route path="/scadenze" element={<Protected><Personale /></Protected>} />
            <Route path="/listino" element={<Protected><PriceList /></Protected>} />
            <Route path="/abbonamento" element={<Protected requireOnboarding={false}><Subscription /></Protected>} />
            <Route path="/abbonamento/success" element={<Protected requireOnboarding={false}><Subscription /></Protected>} />
            <Route path="/profilo" element={<Protected requireOnboarding={false}><Profile /></Protected>} />
            <Route path="/admin" element={<Protected requireOnboarding={false}><Admin /></Protected>} />
            <Route path="/referral" element={<Protected requireOnboarding={false}><Referral /></Protected>} />
            <Route path="/computo" element={<Protected><ComputoVerify /></Protected>} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/termini" element={<Terms />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
          <Toaster richColors theme="dark" position="top-center" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
